import { AuthN, getConfig } from '@seek/online-identity';

import { awaitLoginWithRedirect } from './loginWithRedirect';

export type TokenResult = string | null | void;
class AuthService {
  authN?: AuthN;

  async getToken(): Promise<TokenResult> {
    if (!this.authN) {
      this.authN = new AuthN(getConfig('seekAnz-hirer', window.location));
    }

    try {
      return await this.authN.getToken();
    } catch (err: any) {
      if (err.error === 'login_required' || err.error === 'invalid_grant') {
        await awaitLoginWithRedirect(this.authN);
        return null;
      }
      throw err;
    }
  }

  async getIdentity() {
    if (!this.authN) {
      this.authN = new AuthN(getConfig('seekAnz-hirer', window.location));
    }

    return this.authN.getIdentity({ ignoreIdPrefixStrip: true });
  }

  async loginWithRedirect() {
    if (!this.authN) {
      this.authN = new AuthN(getConfig('seekAnz-hirer', window.location));
    }

    try {
      await awaitLoginWithRedirect(this.authN);
    } catch (err: any) {
      throw err;
    }
  }
}

export default new AuthService();
